var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CRow',[_c('CCol',{attrs:{"md":"12"}},[(_vm.userType === 'Verifier')?_c('div',[_c('staff-calendar')],1):_vm._e(),(_vm.userType === 'Admin')?_c('div',[_c('calendar-view')],1):_vm._e()])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }